// @flow
import moment from 'moment';

const HOURS_THRESHOLD = 24;

export function formatMessageTimestamp(createdAt: string): string {
  const messageTime = moment.utc(createdAt).local();

  if (moment().diff(moment.utc(createdAt), 'hours') < HOURS_THRESHOLD) {
    return messageTime.fromNow();
  }

  return `${messageTime.format('MM/DD/YYYY')} \u2022 ${messageTime.format(
    'h:mm A',
  )}`;
}
